import React from 'react';
import PropTypes from 'prop-types';
import { FlexContainer } from '../../styled/layout.styled';
import { StyledTitle } from '../../styled/typograpghy.styled';

const DashBoardLayout = ({
  title, children, component, mobilePadding,
}) => (
  <FlexContainer
    flexDirection="column"
    padding="42px 0 178px 38px"
    tabletPadding="58px 24px 333px 24px"
    mobilePadding={mobilePadding || '22px 16px 112px 16px'}
    width="800px"
    mobileWidth="100%"
    tabletWidth="100%"
  >
    {component ? (
      <FlexContainer alignItems="center" justifyContent="space-between" mobileFlexDirection="column">
        <FlexContainer mobileWidth="100%" mobileJustifyContent="center" mobileMargin="0 0 28px 0">
          <StyledTitle tabletMargin="0 0 0 40px" mobileFontSize="20px">
            {title}
          </StyledTitle>
        </FlexContainer>
        {component}
      </FlexContainer>
    ) : (
      <FlexContainer mobileWidth="100%" mobileJustifyContent="center" mobileMargin="0 0 28px 0">
        <StyledTitle
          fontSize="28px"
          fontWeight="800"
          lineHeight="1.29"
          tabletMargin="0 0 0 40px"
          mobileMargin="0"
          mobileFontSize="20px"
        >
          {title}
        </StyledTitle>
      </FlexContainer>
    )}
    {children}
  </FlexContainer>
);

DashBoardLayout.propTypes = {
  title: PropTypes.string.isRequired,
  component: PropTypes.node,
  children: PropTypes.node.isRequired,
  mobilePadding: PropTypes.string,
};

DashBoardLayout.defaultProps = {
  component: null,
  mobilePadding: '',
};
export default DashBoardLayout;
